import { render, staticRenderFns } from "./centralRescann.vue?vue&type=template&id=074c37c9&scoped=true&"
import script from "./centralRescann.vue?vue&type=script&lang=js&"
export * from "./centralRescann.vue?vue&type=script&lang=js&"
import style0 from "./centralRescann.vue?vue&type=style&index=0&id=074c37c9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "074c37c9",
  null
  
)

export default component.exports